"use client";

import { useState, useEffect } from "react";
import {
  ChevronLeft,
  ChevronRight,
  Clock,
  Heart,
  MapPin,
  Sparkles,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import "../styles/trendingprofile.css";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { useDispatch, useSelector } from "react-redux";
import { deleteWithTokenBodyAPI, postWithTokenAPI } from "../util/Api";
import { Button } from "./ui/button";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { useTranslation } from "react-i18next";

export function TrendingProfilesSlider({
  profiles = [],
  onNavigate,
  layoutType,
}) {
  const [FilterProfiles, setFilterProfiles] = useState(profiles);
  useEffect(() => {
    setFilterProfiles(profiles);
  }, [profiles]);

  console.log(FilterProfiles, "FilterProfiles");

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(4);
  const [direction, setDirection] = useState(0);
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 640) setVisibleCards(1);
      else if (width < 1024) setVisibleCards(2);
      else setVisibleCards(4);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 800, // animation speed
      easing: "ease-out-cubic",
      once: true, // only animate first time
      offset: 50, // trigger point
    });

    AOS.refresh();
  }, []);

  // Pagination logic
  const totalPages = Math.ceil(FilterProfiles.length / visibleCards);
  const startIndex = currentIndex * visibleCards;
  const endIndex = Math.min(startIndex + visibleCards, FilterProfiles.length);
  const visibleProfiles =
    layoutType === "Showall"
      ? FilterProfiles
      : FilterProfiles.slice(startIndex, endIndex);

  const showArrows = FilterProfiles.length > visibleCards;
  const showPrev = showArrows && currentIndex > 0;
  const showNext = showArrows && currentIndex < totalPages - 1;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const id = data?.userId?.user?._id;

  const fixImageUrl = (url) => {
    if (!url || typeof url !== "string") {
      return ""; // or return a fallback image URL
    }

    return url.replace("http://", "https://");
  };
  const handlePrev = () => {
    if (currentIndex > 0) {
      setDirection(-1);
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNext = () => {
    if (currentIndex < totalPages - 1) {
      setDirection(1);
      setCurrentIndex(currentIndex + 1);
    }
  };

  const containerVariants = {
    enter: (direction) => ({
      opacity: 0,
      x: direction > 0 ? 80 : -80,
    }),
    center: {
      opacity: 1,
      x: 0,
    },
    exit: (direction) => ({
      opacity: 0,
      x: direction > 0 ? -80 : 80,
    }),
  };

  const transitionVariants = {
    transition: {
      x: { type: "tween", duration: 0.35 },
      opacity: { duration: 0.25 },
    },
  };

  const handleInterestToggle = async (profile) => {
    if (!token) {
      setShowLoginDialog(true);
      return;
    } else if (profile.interest) {
      try {
        const payload = {
          from_user_id: id,
          to_user_id: profile?.user_id || profile?.basicProfile?.user_id,
        };
        const response = await deleteWithTokenBodyAPI(
          token,
          `/interest/delete`,
          payload
        );

        if (response?.statusCode === 200) {
          toast.success(t("Interest Deleted Successfully"));

          setFilterProfiles((prevProfiles) =>
            prevProfiles.map((p) =>
              (p.user_id || p?.basicProfile?.user_id) === payload.to_user_id
                ? { ...p, interest: false }
                : p
            )
          );
        } else {
          toast.error(t("Already Deleted interest"));
        }
      } catch (error) {
        toast.error(t("Something went wrong while sending interest!"));
      }
    } else {
      try {
        const payload = {
          from_user_id: id,
          to_user_id: profile?.user_id || profile?.basicProfile?.user_id,
        };

        const response = await postWithTokenAPI(
          token,
          `/interest/create`,
          payload
        );

        if (response?.statusCode === 200) {
          toast.success(t("Interest Sent Successfully"));

          setFilterProfiles((prevProfiles) =>
            prevProfiles.map((p) =>
              (p.user_id || p?.basicProfile?.user_id) === payload.to_user_id
                ? { ...p, interest: true }
                : p
            )
          );
          // console.log(updatedProfiles, "updatedProfiles")
          // setFilterProfiles(updatedProfiles);
        } else {
          toast.error(t("Already sent interest"));
        }
      } catch (error) {
        toast.error(t("Something went wrong while sending interest!"));
      }
    }
  };

  const handleViewProfile = (profile) => {
    if (!token) {
      setShowLoginDialog(true);
      return;
    }
    onNavigate?.(profile);
  };
  const isLastPage =
    currentIndex === totalPages - 1 &&
    profiles.length == 4 &&
    layoutType !== "Showall ";

  const getTimeAgo = (dateString) => {
    if (!dateString) return "";

    const dateUTC = new Date(dateString);
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(dateUTC.getTime() + istOffset);

    const nowIST = new Date(Date.now() + istOffset);

    let diff = (nowIST - istDate) / 1000;

    // 👇 FIX negative time issues
    if (diff < 0) diff = 0;

    const days = diff / 86400;

    if (days < 30) {
      if (diff < 60) return "Just now";
      if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
      if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
      return `${Math.floor(days)}  ${days<2 ? `day ago` : `days ago`}`;
    }

    return istDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <section className="trending-slider-section">
      <div className="trending-slider-container">
        <div className="slider-wrapper">
          <AnimatePresence>
            {showPrev && layoutType !== "Showall" && (
              <motion.button
                key="prev-btn"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                onClick={handlePrev}
                className="slider-button slider-button-prev"
                aria-label="Previous profiles"
              >
                <motion.div
                  whileHover={{ scale: 1.15 }}
                  whileTap={{ scale: 0.9 }}
                  className="button-inner"
                >
                  <ChevronLeft className="button-icon" />
                </motion.div>
              </motion.button>
            )}
          </AnimatePresence>

          <div className="cards-container">
            <AnimatePresence mode="wait" custom={direction}>
              <motion.div
                key={currentIndex}
                custom={direction}
                variants={containerVariants}
                initial="enter"
                animate="center"
                exit="exit"
                {...transitionVariants}
                className={`cards-grid ${
                  layoutType !== "Showall" && isLastPage ? "grid-5" : ""
                }`}
              >
                {visibleProfiles.map((profile, index) => (
                  <motion.div
                    key={profile?._id || `profile-${index}`}
                    // initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.0 }}
                    whileHover={{ y: -8 }}
                    className="profile-card"
                    data-aos-delay={index * 100}
                  >
                    <div className="profile-badge-like">
                      <button
                        onClick={() => handleInterestToggle(profile)}
                        style={{
                          position: "relative",
                          borderRadius: "50%",
                          width: "48px",
                          height: "48px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          background: "transparent",
                          border: "none",
                          // transition: "all 1s ease-in-out",
                        }}
                      >
                        <Heart
                          style={{
                            width: "24px",
                            height: "24px",
                            transition: "all 0.3s ease-in-out",
                            fill: profile.interest ? "#ef4444" : "#ffffff",
                            color: profile.interest ? "#ef4444" : "#ffffff",
                            transform: profile.interest
                              ? "scale(1.1)"
                              : "scale(1)",
                          }}
                        />
                      </button>
                    </div>

                    <div className="profile-image-wrapper">
                      <ImageWithFallback
                        src={
                          fixImageUrl(profile?.basicProfile?.profileImage) ||
                          fixImageUrl(profile?.profileImage) ||
                          " "
                        }
                        alt={profile.name}
                        className="w-full h-64 object-cover"
                        style={{ objectPosition: "top" }}
                      />
                      {profile?.basicProfile?.name && (
                        <div className="profile-badge">{t("Top Profile")}</div>
                      )}
                      <div className="image-overlay" />
                    </div>

                    <div
                      className="card-content"
                      onClick={() => {
                        handleViewProfile(profile);
                      }}
                    >
                      <h3 className="profile-name">
                        {profile?.basicProfile?.name ||
                          profile?.name ||
                          "Profile Name"}
                      </h3>

                      <p className="profile-description py-1 ">
                        <MapPin size={14} className="text-red-500" />
                        {profile?.basicProfile?.district || profile?.district}
                      </p>

                      <div
                        className={`badges-container ${
                          profile?.basicProfile?.name ? "mt-2 mb-2" : ""
                        }`}
                      >
                        {(profile?.basicProfile?.age || profile?.age) && (
                          <span className="badge">
                            {profile?.basicProfile?.age || profile?.age}{" "}
                            {t("years old")}
                          </span>
                        )}
                        {profile?.basicProfile?.name && (
                          <span className="badge trending">
                            🔥 {t("Trending")}
                          </span>
                        )}
                      </div>
                      {(profile?.sent_at ||
                        profile?.received_at ||
                        profile?.viewed_at) && 
                          (<div
                            className="flex items-center gap-2  py-1 
    bg-white
    rounded-full text-gray-700 text-sm font-semibold"
                          >
                            <Clock size={14} className="text-gray-500" />
                            <span>
                              {getTimeAgo(
                                profile?.sent_at ||
                                  profile?.received_at ||
                                  profile?.viewed_at
                              )}
                            </span>
                          </div>)
                        }


                      <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        onClick={() => handleViewProfile(profile)}
                        // onClick={() => onNavigate?.(profile)}
                        className="cta-button cursor-pointer"
                        style={{ paddingTop: "12px" }}
                      >
                        {t("View Profile")}
                      </motion.button>
                    </div>

                    <div className="card-accent-line" />
                  </motion.div>
                ))}

                {layoutType !== "Showall" && isLastPage && (
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    className="explore-all-card"
                  >
                    <motion.div
                      className="explore-list-item"
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={() => navigate("/browse")}
                    >
                      <div className="heart-arrow-container">
                        <div className="pink-heart-animation">
                          <div className="heart-main"></div>
                          <div className="heart-glow"></div>
                        </div>
                        <div className="arrow-icon">→</div>
                      </div>
                      <span className="explore-all-text">
                        {t("Explore All")}
                      </span>
                    </motion.div>
                    <div className="card-accent-line" />
                  </motion.div>
                )}
              </motion.div>
            </AnimatePresence>
          </div>

          <AnimatePresence>
            {showNext && layoutType !== "Showall" && (
              <motion.button
                key="next-btn"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                onClick={handleNext}
                className="slider-button slider-button-next"
                aria-label="Next profiles"
              >
                <motion.div
                  whileHover={{ scale: 1.15 }}
                  whileTap={{ scale: 0.9 }}
                  className="button-inner"
                >
                  <ChevronRight className="button-icon" />
                </motion.div>
              </motion.button>
            )}
          </AnimatePresence>
        </div>
      </div>
      <AlertDialog open={showLoginDialog} onOpenChange={setShowLoginDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("You’re Almost There!")}</AlertDialogTitle>
            <AlertDialogDescription>
              {t("Log in to explore profiles and start connecting")}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setShowLoginDialog(false)}
              className="cursor-pointer"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="text-white cursor-pointer"
              style={{ background: 'linear-gradient(to right bottom, rgb(220, 38, 38), rgb(243, 67, 67))' }}
              onClick={() => {
                setShowLoginDialog(false);
                navigate("/login");
              }}
            >
              {t("Login")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  );
}
